import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ApplyJobListAction } from "../../../Redux/action/ApplyJobListAction";
import { SendRequestAction } from "../../../Redux/action/SendRequestAction";
import NewScheduleInterview from "../../Vendor/interview/NewScheduleInterview";
import { ToastContainer, toast } from "react-toastify";
import { TeamTableAction } from "../../../Redux/action/TeamTableAction";
import TableHeader from "../../Common/TableHeader";
import { TeamApplyJobListAction } from "../../../Redux/action/TeamApplyJobListAction";
import { FormControl, FormControlLabel, FormLabel, Menu, MenuItem, Radio, RadioGroup, TextareaAutosize } from "@mui/material";
import axios from "axios";
import DeactivateModal from "../../Common/DeactivateMemberModal";
import { SpinLoader } from "../ImportCandidates";


const TeamAppliedJobs = () => {
    const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(20);
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [search, setSearch] = useState("");
    const [jobStatus, setJobStatus] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedReason, setSelectedReason] = useState("");
    const [showOtherTextarea, setShowOtherTextarea] = useState(selectedReason === "other");
    const [otherReason, setOtherReason] = useState(""); 
    const [loading, setLoading] = useState(false);

    const userInfo = useSelector((state) => state.TeamAppliedJobs.result);
    const TeamList = useSelector((state) => state.TeamTable.result);

    const isTeamMember = localStorage.getItem("isTeamMember");

    console.log('TEA--', isTeamMember )

    const baseUrl = process.env.REACT_APP_API_PATH;

    let { id } = useParams();
    const { userResult } = useSelector((state) => state.Auth);
    let vendorId = userResult?.vendorid;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    console.log('-0000', userInfo)

    // const handleAccept = async(jobId) => {
    //     const content = {
    //         jobAcceptanceStatus: "ACCEPTED",
    //         appliedJobsId: jobId,
    //     }

    //     const response = await axios.put(`${baseUrl}/ebench/accept_or_reject_job`,content,
    //         {
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //         }
    //     );

    //     const data = await response.data

    //     console.log('DATA REQI--', data)
    //     toast.success('Job request accepted');
    // }

    // const handleReject = async(jobId) => {
    //     const content = {
    //         jobAcceptanceStatus: "REJECTED",
    //         appliedJobsId: jobId,
    //     }

    //     const response = await axios.put(`${baseUrl}/ebench/accept_or_reject_job`,content,
    //         {
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //         }
    //     );

    //     const data = await response.data

    //     console.log('DATA REQI--', data)
    //     toast.success('Job request rejected')
    // }

    useEffect(() => {
        dispatch(TeamApplyJobListAction(vendorId));
    }, [jobStatus]);
    
    useEffect(() => {
        dispatch(TeamTableAction(vendorId));
    }, []);

    const onRequest = (candidateId, jobId, appliedJobsId) => {
        const data = { appliedJobsId };
        dispatch(SendRequestAction(data));
    };

    const Loading = useSelector((state) => state.SendRequestData.loading);

    const handleClick = (e) => {
        setcurrentPage(Number(e.target.id));
    };


    const handleReasonChange = (event) => {
        const value = event.target.value;
        setSelectedReason(value);

        // If "other" is selected, show the textarea
        setShowOtherTextarea(value === "other");
    };

    const pages = [];
    for (let i = 1; i <= Math.ceil(userInfo.length / itemsPerPage); i++) {
        pages.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = userInfo.slice(indexOfFirstItem, indexOfLastItem);
    const newData = userInfo;

    const renderPageNumbers = pages.map((number) => {
        if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
            return (
                <li
                    key={number}
                    id={number}
                    onClick={handleClick}
                    className={currentPage === number ? "active" : null}
                >
                    {number}
                </li>
            );
        } else {
            return null;
        }
    });

    const handleNextbtn = () => {
        setcurrentPage(currentPage + 1);
        if (currentPage + 1 > maxPageNumberLimit) {
            setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
        }
    };

    const handlePrevbtn = () => {
        setcurrentPage(currentPage - 1);
        if ((currentPage - 1) % pageNumberLimit === 0) {
            setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
        }
    };

    let pageIncrementBtn = null;
    if (pages.length > maxPageNumberLimit) {
        pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
    }

    let pageDecrementBtn = null;
    if (minPageNumberLimit >= 1) {
        pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
    }


    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    const handleOtherReasonChange = (event) => {
        setOtherReason(event.target.value);
    };


    const BasicMenu = ({jobId,jobItem}) => {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event) => {
            console.log('HERO')
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);  
        };


        const handleAccept = async(jobId) => {
            setJobStatus('accepted')
            const content = {
                jobAcceptanceStatus: "ACCEPTED",
                appliedJobsId: jobId,
            }
    
            const response = await axios.put(`${baseUrl}/ebench/accept_or_reject_job`,content,
                {
                    headers: {
                        "Content-Type": "application/json"
                    },
                }
            );
    
            const data = await response.data
    
            console.log('DATA REQI--', data)
            toast.success('Job request accepted');
        }
    
        const handleReject = async(jobId) => {
            setJobStatus('rejecteds')
            const content = {
                jobAcceptanceStatus: "REJECTED",
                appliedJobsId: jobId,
                declinedReason: selectedReason
            }
    
            const response = await axios.put(`${baseUrl}/ebench/accept_or_reject_job`,content,
                {
                    headers: {
                        "Content-Type": "application/json"
                    },
                }
            );
    
            const data = await response.data
    
            console.log('DATA REQI--', data)
            closeModal()
            toast.success('Job request rejected')
        }
        

        return (
            <div>
                <Button
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                >
                    Actions
                </Button>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={handleClose}>
                        <button 
                        disabled={jobItem.jobAcceptanceStatus === 'ACCEPTED' || jobItem.jobAcceptanceStatus === 'REJECTED'} 
                        className={`act_btn ${(jobItem.jobAcceptanceStatus === 'ACCEPTED' || jobItem.jobAcceptanceStatus === 'REJECTED') && 'act_green_disabled'}`} onClick={()=>handleAccept(jobId)} style={{ backgroundColor: 'green' }}>
                            Accept
                        </button>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>
                        <button 
                        // disabled={jobItem.jobAcceptanceStatus === 'ACCEPTED' || jobItem.jobAcceptanceStatus === 'REJECTED'}
                         className={`act_btn ${(jobItem.jobAcceptanceStatus === 'ACCEPTED' || jobItem.jobAcceptanceStatus === 'REJECTED') && 'act_red_disabled'}`} 
                        //  onClick={() => handleReject(jobId)} 
                         onClick={openModal} 
                         style={{ backgroundColor: 'red', color: 'white' }}>
                            Reject
                        </button>
                    </MenuItem>
                    {/* <MenuItem onClick={handleClose}>Request List</MenuItem> */}
                </Menu>


                <DeactivateModal isOpen={isModalOpen} onClose={closeModal} heading={'Reason for Rejecting'} >
                        <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label">Reasons</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                // defaultValue="female"
                                name="radio-buttons-group"
                                value={selectedReason}
                                onChange={handleReasonChange}
                            >
                                <FormControlLabel className='mb-2' value="Lack of qualifications for the position." control={<Radio />} label="Lack of qualifications for the position." />
    
                                <FormControlLabel className='mb-2' value="A stronger candidate was selected for the role." control={<Radio />} label="A stronger candidate was selected for the role." style={{ textAlign: 'left' }}  />
    
                                <FormControlLabel className='mb-2' value="Lack of relevant experience." control={<Radio />} label="Lack of relevant experience." style={{ textAlign: 'left' }}  />

                                <FormControlLabel className='mb-2' value="Insufficient technical skills" control={<Radio />} label="Insufficient technical skills" style={{ textAlign: 'left' }}  />
    
                                {/* <FormControlLabel className='mb-2' control={<Radio />} value={'other'} label="Others"
                                //  onClick={handleOtherReason}
                                />
    
                                {showOtherTextarea && (
                                    <TextareaAutosize
                                        value={otherReason}
                                        onChange={handleOtherReasonChange}
                                        placeholder="Other Reason"
                                        minRows={5}
                                        maxRows={5}
                                    />
                                )} */}
                            </RadioGroup>
    
    
                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    style={{ background: '#1c6597', color: '#fff',marginRight:'10px',width: "100px",
    							height: "40px", }}
                                    onClick={()=>handleReject(jobId)} // Add your submit logic here
                                >
                                    {!loading ? "Submit" : <SpinLoader />}
                                </Button>
                                {/* <Button
                                    style={{ background: '#c60b0b', color: '#fff' }}
                                    variant="contained"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </Button> */}
                            </div>
                        </FormControl>
                    </DeactivateModal>
            </div>
        );
    };

    return (
        <div>
            <ToastContainer />
            <div
                className="card-header"
                style={{
                    background: "#f1fdff",
                    height: "auto",
                    paddingBottom: "100px",
                }}
            >
                <TableHeader heading={"Team Member's Job List"} />
                <div className="">
                    <div className="table-responsive">
                        <table className="table-data">
                            <thead>
                                <tr>
                                    <th scope="col">Job Id</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Job Designation</th>
                                    <th scope="col">Job Title</th>
                                    <th scope="col">Candidate Status</th>
                                    <th scope="col">Required Experience</th>
                                    {!isTeamMember && <th scope="col">Action</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems &&
                                    currentItems.map((item, i) => {
                                        return (
                                            <>
                                                <tr key={i}>
                                                    <td>#{item.appliedJobsId}</td>
                                                    <td>{item.candidateName}</td>
                                                    <td className="" data-tooltip={item.candidateEmail}>
                                                        {item.candidateEmail}
                                                    </td>
                                                    <td>{item.role}</td>
                                                    <td>{item.jobTitle}</td>
                                                    {item.jobAcceptanceStatus === "ACCEPTED" ? (
                                                        <td >
                                                            <button className="applyJob_acceptBtn">Accepted By Candidate</button>
                                                        </td>
                                                    ) : item.jobAcceptanceStatus === "REJECTED" ? (
                                                        <td>
                                                            <button className="applyJob_rejBtn arc_tooltip" data-tooltip={item.declinedReason}>Rejected By Candidate</button>
                                                        </td>
                                                    ) : <td>
                                                        <button className="applyJob_rejBtn">Job Request Pending</button>
                                                    </td>}
                                                    <td>{item.requiredExperience}</td>


                                                    {!isTeamMember && <td>
                                                        <BasicMenu jobId={item.appliedJobsId} jobItem={item} />
                                                    </td>}
                                                </tr>
                                            </>
                                        );
                                    })}
                            </tbody>
                        </table>

                        {currentItems.length === 0 && (
                            <div className="text-center mt-5">
                                <h5>No Data Available</h5>
                            </div>
                        )}
                    </div>
                </div>
                {userInfo.length >= 5 ? (
                    <div className="mt-4">
                        <ul className="pageNumbers">
                            <li>
                                <button
                                    onClick={handlePrevbtn}
                                    disabled={currentPage === pages[0] ? true : false}
                                >
                                    Prev
                                </button>
                            </li>
                            {pageDecrementBtn}
                            {renderPageNumbers}
                            {pageIncrementBtn}
                            <li>
                                <button
                                    onClick={handleNextbtn}
                                    disabled={
                                        currentPage === pages[pages.length - 1] ? true : false
                                    }
                                >
                                    Next
                                </button>
                            </li>
                        </ul>
                    </div>
                ) : (
                    ""
                )}
            </div>


            
        </div>
    );
};

export default TeamAppliedJobs;
